// A deal's field as the form marks it (fieldMarks.js): a star when a save requires it; with the
// flow on (TX-US-0043), a flag beside its label when the next move waits on it, and, when an
// approved round agreed it, the field disabled with a flag saying how it is changed. The API
// refuses a locked change regardless; this shows it before a save is refused.

// `field` is the API's name for the field; `marks` the form's required, needed and locked sets.
export function FieldFlags({ field, marks }) {
  const required = marks.required.has(field);
  const needed = marks.needed.has(field);
  const locked = marks.locked.has(field);
  if (!required && !needed && !locked) return null;
  return (
    <>
      {required && (
        <>
          {' '}<span className="req" aria-hidden="true">*</span>
          <span className="visually-hidden"> (required)</span>
        </>
      )}
      {needed && <span className="field-flag needed">needed to move on</span>}
      {locked && (
        <span className="field-flag locked" title="Reopen the proposal to change it">
          approved · reopen to change
        </span>
      )}
    </>
  );
}

// A disabled fieldset disables every control inside it, the add-entry buttons included, without
// each control being told. It lays out as if absent (`display: contents`).
export function Locked({ field, marks, children }) {
  if (!marks.locked.has(field)) return children;
  return <fieldset className="fieldset-contents" disabled>{children}</fieldset>;
}
